import { makeStyles, shorthands } from "@fluentui/react-components";

export const useDetailsStyles = makeStyles({
  detailsButton: {
    alignSelf: "flex-start",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("16px"),
  },
  detailsCard: {
    display: "flex",
    ...shorthands.gap("8px"),
    flexGrow: 0,
    flexShrink: 0,
  },
});
